import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SectionTitle from '../shared/SectionTitle';
import InfoCard from '../shared/InfoCard';
import { t } from '../../../../utils/textUtils';
import { formatCurrency } from '../utils/formatters';
import { DETAIL_GRID_SX } from '../utils/constants';

const ProjectValueTab = ({ project }) => (
  <>
    <SectionTitle
      title={t('NILAI PROYEK')}
      subtitle={t('Ringkasan anggaran dan skema pembayaran.')}
    />

    <Box sx={DETAIL_GRID_SX}>
      <InfoCard
        label={t('NILAI PROYEK')}
        value={formatCurrency(project.totalAnggaran)}
        icon={<AttachMoneyIcon sx={{ color: '#16A34A' }} />}
      />
      <InfoCard
        label={t('SUMBER DANA')}
        value={project.sumberDana || t('TIDAK DITENTUKAN')}
        icon={<AttachMoneyIcon sx={{ color: '#0EA5E9' }} />}
      />
      <InfoCard
        label={t('RENCANA PEMBAYARAN')}
        value={project.rencanaPembayaran || t('TIDAK DITENTUKAN')}
        icon={<AttachMoneyIcon sx={{ color: '#F59E0B' }} />}
      />
    </Box>

    {project.detailPembayaran && (
      <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, borderColor: 'divider', mt: 2.5 }}>
        <Typography variant="caption" color="text.secondary">
          {t('DETAIL RENCANA PEMBAYARAN')}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a', mt: 0.5 }}>
          {project.detailPembayaran}
        </Typography>
      </Paper>
    )}
  </>
);

export default ProjectValueTab;
